module.exports = __webpack_public_path__ + "static/media/my-needs-icon-active.4041ea5f.svg";